import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { LoaderService } from 'src/shared/services';
import { ZoningCodeService } from 'src/app/core/services/zoning-code.service';
import { ToastrService } from 'ngx-toastr';
import IZoningCodesImportValidationResult = ZoneIQCalibration.IZoningCodesImportValidationResult;
import IZoningCodeImportRowData = ZoneIQCalibration.IZoningCodeImportRowData;
import { BehaviorSubject, Observable, asyncScheduler } from 'rxjs';
import { ImportTableWorkflowBaseComponent } from '../shared/import-table-workflow.base';

@Component({
    standalone: false,
    selector: 'app-zoning-codes-import-table',
    templateUrl: './zoning-codes-import-table.component.html',
    styleUrls: ['./zoning-codes-import-table.component.scss']

})
export class ZoningCodesImportTableComponent extends ImportTableWorkflowBaseComponent<IZoningCodesImportValidationResult> implements OnInit {
    readonly zoningCodesValidationData$ = new BehaviorSubject<IZoningCodesImportValidationResult>(null);
    readonly zoningCodesRows$ = new BehaviorSubject<IZoningCodeImportRowData[]>([]);
    private zoningCodesValidationData: IZoningCodesImportValidationResult = null;

    constructor(
        private readonly zoningCodeService: ZoningCodeService,
        loaderService: LoaderService,
        dialog: MatDialog,
        toastrService: ToastrService
    ) {
        super(loaderService, dialog, toastrService);
    }

    ngOnInit(): void {}

    clearUsesTable(): void {
        this.selectedFileData = null;
        this.resetValidationData();
    }

    getIsCorrectModules(zcRow: IZoningCodeImportRowData) {
        return zcRow?.modules?.every(m => {
            return m.importValidationResult && m.importValidationResult.isValid;
        });
    }

    protected getValidationData(): IZoningCodesImportValidationResult {
        return this.zoningCodesValidationData;
    }

    protected resetValidationData(): void {
        this.zoningCodesValidationData = null;
        this.zoningCodesValidationData$.next(null);
        this.zoningCodesRows$.next([]);
    }

    protected setValidationData(result: IZoningCodesImportValidationResult): void {
        asyncScheduler.schedule(() => {
            this.zoningCodesValidationData = result;
            this.zoningCodesValidationData$.next(result);
            this.zoningCodesRows$.next(_.get(result, 'zoningCodesRows', []));
        });
    }

    protected getImportConfirmationMessage(): string {
        return `Only NEW Zoning Codes and Municipalities will be imported. Existing codes and municipalities will be ignored. Continue?`;
    }

    protected runValidationRequest(): Observable<IZoningCodesImportValidationResult> {
        return this.zoningCodeService.importZoningCodes(this.selectedFileData, true);
    }

    protected runImportRequest(): Observable<any> {
        return this.zoningCodeService.importZoningCodes(this.selectedFileData);
    }

    protected getErrorMessage(err: any): string {
        return _.get(err, 'error.messages', []).join('. ');
    }
}
